import styled from 'styled-components';
import { ErrorText as ErrorMessage } from 'ui/formField';
import { HelpToggletip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

export const StyledToggletipCentered = styled(HelpToggletip)`
  top: -${pxToRem(2)};
`;

export const ErrorText = styled(ErrorMessage)`
  padding-left: ${pxToRem(55)};
`;
